// LOAD CHECK — if you do not see this line, the file is not being loaded at all
console.log('[DrawerDesktop] FILE LOADED');

/**
 * header-drawer-desktop.js — DEBUG BUILD
 */
(function () {
  'use strict';

  // EXECUTION CHECK — if you see FILE LOADED but not this, the IIFE is broken
  console.log('[DrawerDesktop] IIFE EXECUTING');

  const HEADER_ID   = 'header-component';
  const ATTR        = 'data-menu-style';
  const FORCE_VALUE = 'drawer';
  const DEBUG       = false;

  function log(...args) {
    if (DEBUG) console.log('[DrawerDesktop]', ...args);
  }

  function warn(...args) {
    if (DEBUG) console.warn('[DrawerDesktop]', ...args);
  }

  function enforceDrawerMode(header) {
    const current = header.getAttribute(ATTR);
    if (current !== FORCE_VALUE) {
      header.setAttribute(ATTR, FORCE_VALUE);
      log(`Corrected: "${current}" → "${FORCE_VALUE}"`);
      return true;
    }
    return false;
  }

  function debugState(header) {
    const overflowList = header.querySelector('overflow-list');
    log('--- State Snapshot ---');
    log(`  Viewport           : ${window.innerWidth}px x ${window.innerHeight}px`);
    log(`  isTouchDevice      : ${'ontouchstart' in window && navigator.maxTouchPoints > 0}`);
    log(`  maxTouchPoints     : ${navigator.maxTouchPoints}`);
    log(`  ontouchstart       : ${'ontouchstart' in window}`);
    log(`  overflow-list found: ${!!overflowList}`);
    log(`  minimum-reached    : ${overflowList ? overflowList.hasAttribute('minimum-reached') : 'n/a'}`);
    log(`  ${ATTR}            : "${header.getAttribute(ATTR)}"`);
    log('----------------------');
  }

  function init() {
    log('init() called');
    log(`document.readyState: "${document.readyState}"`);

    const header = document.getElementById(HEADER_ID);

    if (!header) {
      warn(`#${HEADER_ID} not found in DOM — script has no effect.`);
      return;
    }

    log(`#${HEADER_ID} found`);
    debugState(header);

    const changed = enforceDrawerMode(header);
    if (!changed) {
      log(`Attribute already "${FORCE_VALUE}" on init — no correction needed`);
    }

    const observer = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        if (mutation.attributeName !== ATTR) continue;

        const newValue = header.getAttribute(ATTR);
        log(`MutationObserver fired`);
        log(`  oldValue: "${mutation.oldValue}"`);
        log(`  newValue: "${newValue}"`);

        if (newValue !== FORCE_VALUE) {
          log(`  Trigger: likely setHeaderMenuStyle() via rAF`);
          log(`  Action: overriding → "${FORCE_VALUE}"`);
          enforceDrawerMode(header);
          debugState(header);
        } else {
          log(`  Already "${FORCE_VALUE}" — no action`);
        }
      }
    });

    observer.observe(header, {
      attributes: true,
      attributeFilter: [ATTR],
      attributeOldValue: true,
    });

    log('MutationObserver attached');

    let resizeCount = 0;
    window.addEventListener('resize', function () {
      resizeCount++;
      if (resizeCount % 5 === 0) {
        log(`resize event #${resizeCount} → width: ${window.innerWidth}px | ${ATTR}: "${header.getAttribute(ATTR)}"`);
      }
    });

    log('Ready — watching for setHeaderMenuStyle() calls');
  }

  if (document.readyState === 'loading') {
    log('DOM not ready — deferring to DOMContentLoaded');
    document.addEventListener('DOMContentLoaded', init);
  } else {
    log('DOM already ready — running init immediately');
    init();
  }

})();